import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { generateCognitoPhoneFormat } from '../../CustomerPortalUtil';
import Swal from 'sweetalert2'
import { AvantoCognitoService } from 'src/app/services/avanto-cognito.service';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: [
    './sign-up.component.scss',
    '../customer-authentication.component.scss',
    '../../../../../../../node_modules/daemonite-material/css/material.min.css'
  ]
})
export class SignUpComponent implements OnInit {

  @Output() signUpSuccessfull = new EventEmitter();
  @Output() signUpFailed = new EventEmitter();

  showTermsAndConditions:boolean

  name: string;
  email: string;
  phone: string;
  password: string;
  confirmPassword: string;

  btnBlocked: boolean;

  constructor(private cognito: AvantoCognitoService) { }

  ngOnInit() {
    this.btnBlocked = false;
    this.showTermsAndConditions = true;
  }

  acceptTermsAndConditionsClicked(){
    this.showTermsAndConditions = false;
  }

  matchPasswords() {
    return this.password == this.confirmPassword;
  }

  cancelSignup(){
    this.signUpFailed.emit()
  }

  signup() {
    //We do this to prevent the user from clicking like a lunatic
    this.btnBlocked = true;

    this.cognito.signUp(this.email, generateCognitoPhoneFormat(this.phone), this.name, this.password)
      .then((response) => {
        this.btnBlocked = false;
        this.signUpSuccessfull.emit({ usr: this.phone, pass: this.password })
      })
      .catch((errorResponse) => {
        this.btnBlocked = false;
        if (errorResponse.code == "UsernameExistsException") {
          Swal.fire('An account using this phone number already exists.', "Please, try logging in with it.", 'error')
        } else {
          Swal.fire('We could not complete the registration.', errorResponse.message, 'error')
        }
      });
  }
}